import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router';
import i18n from './plugins/i18n.js';

loadFonts()

const app = createApp(App);

app.use(vuetify);
app.use(router);
app.use(i18n)

app.mount('#app');



  // new Vue({
  //   router,
  //   render: h => h(App),
  // }).$mount('#app');